<div class="container-fluid blotter_top_interaction_bar" #topMenu>
  <div class="blotter_titlebar_interaction">
    <div class="blotter_filter_bar_container">
      <div
        class="bfx-blotter-filter-bar blotter_filter_bar"
        [blotterInstance]="blotterInstance"
      ></div>
    </div>
    <div class="bfx-blotter-tools-container">
      <bfx-quick-search
        class="bfx-quick-search"
        [(ngModel)]="searchValue"
        (ngModelChange)="onChangeSearchValue()"
      ></bfx-quick-search>
      <div class="blotter_titlebar_interaction_right">
        <bfx-icon-button
          size="sm"
          iconClass="icon_ion_filter_filled"
          (action)="showFilterManager($event)"
          title="Filter Manager"
        ></bfx-icon-button>
        <!--
              OMS-34147 only entry - save default no longer applies to intervention
            <label (click)="settingsMenu.toggle($event)" class="btn btn-default blotter_interaction_buttons icon icon_ion_settings_filled" title="Settings"><bfx-blotter-settings-menu #settingsMenu></bfx-blotter-settings-menu></label>
            -->
      </div>
    </div>
  </div>
</div>

<div class="blotter_table_target" #tableTarget>
  <ag-grid-angular
    style="width: 100%; height: 100%"
    class="ag-bcdfx pinned-border"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [toolPanelSuppressSideButtons]="true"
    [frameworkComponents]="frameworkComponents"
    enableColResize
    enableSorting
    rowHeight="22"
    (mouseup)="onMouseUp($event)"
    multiSortKey="ctrl"
    (contextmenu)="handleClick($event)"
  >
  </ag-grid-angular>
</div>
<bfx-intervention-context-menu
  *ngIf="!embeddedTableMode"
  [currentLadderBlotter]="blotterInstance"
  bfxElementOnBody
></bfx-intervention-context-menu>
<bfx-blotter-column-selector
  [currentLadderBlotter]="blotterInstance"
  bfxElementOnBody
></bfx-blotter-column-selector>
